import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  BrowserRouter,
} from "react-router-dom";
import "./App.css";
import AdminLayout from "./components/layout/AdminLayout";

import Customer from "./pages/Customer";
import Dashboard from "./pages/Dashboard";
import JcpEnrollment from "./pages/enrollment-jcp/JcpEnrollment";
import JcpEnrollmentReceiptList from "./pages/enrollment-jcp/JcpEnrollmentReceiptList";
import Login from "./pages/Login";
import Account from "./pages/masters/Account";
import AccountGroup from "./pages/masters/AccountGroup";
import Api from "./pages/masters/Api";
import Coach from "./pages/masters/Coach";
import Gst from "./pages/masters/Gst";
import Occupation from "./pages/masters/Occupation";
import PaymentMode from "./pages/masters/PaymentMode";
import ProgramCommercial from "./pages/masters/ProgramCommercial";
import Programme from "./pages/masters/Programme";
import ProgrammeGroup from "./pages/masters/ProgrammeGroup";
import TimeSlot from "./pages/masters/TimeSlot";
import NotFound from "./pages/NotFound";
import Payment from "./pages/payment/Payment";
import PaymentList from "./pages/payment/PaymentList";
import Registration from "./pages/registration/Registration";
import Registrationlist from "./pages/registration/Registrationlist";
import VoucherList from "./pages/voucher/VoucherList";
import ProtectedRoute from "./utility/ProtectedRoute";
import store from "./store/store";
import Logout from "./pages/Logout";
import JcpEnrollmentMonthly from "./pages/enrollment-jcp/JcpEnrollmentMonthly";
import JcpMonthlyPaidList from "./pages/enrollment-jcp/JcpMonthlyPaidList";
import JcpMonthlyReminder from "./pages/enrollment-jcp/JcpMonthlyReminder";
import OtherItemsListJCP from "./pages/otheritems/OtherItemsListJCP";
import AccountReport from "./pages/report/AccountReport";
import TapMemberRegistration from "./pages/tap/TapMemberRegistration";
import TapRegisteredMemberList from "./pages/tap/TapRegisteredMemberList";
import TapBooking from "./pages/tap/TapBooking";
import TapBookingList from "./pages/tap/TapBookingList";
import HpEnrollment from "./pages/enrollment-high-performance/HpEnrollment";
import HpReceiptList from "./components/enrollment/hp/HpReceiptList";
import HpEnrollmentReceiptList from "./pages/enrollment-high-performance/HpEnrollmentReceiptList";
import HpEnrollmentMonthly from "./pages/enrollment-high-performance/HpEnrollmentMonthly";
import HpMonthlyReminder from "./pages/enrollment-high-performance/HpMonthlyReminder";
import ContraVoucher from "./pages/account/ContraVoucher";
import ContraVoucherList from "./pages/account/ContraVoucherList";
import JournalVoucher from "./pages/account/JournalVoucher";
import JournalVoucherList from "./pages/account/JournalVoucherList";
import GeneralVoucher from "./pages/account/GeneralVoucher";
import GeneralVoucherList from "./pages/account/GeneralVoucherList";
import Holiday from "./pages/masters/Holiday";
import Purchase from "./pages/purchase/Purchase";
import PurchaseList from "./pages/purchase/PurchaseList";
import commonUtility from "./utility/Utils";
import TaxInvoice from "./pages/taxinvoice/TaxInvoice";
import TaxInvoiceList from "./pages/taxinvoice/TaxInvoiceList";
import TimeScheduleReport from "./pages/programme-report/TimeScheduleReport";
import TimeScheduleReportView from "./pages/programme-report/TimeScheduleReportView";
import ScheduleChange from "./pages/schedule-change/ScheduleChange";
import PhysicalFitnessEnrollmentEntry from "./components/enrollment/physicallfitness/PhysicalFitnessEnrollmentEntry";
import PhysicallFitnessEnrollment from "./pages/physical-fitness/PhysicallFitnessEnrollment";
import PhysicallFitnessReceiptList from "./pages/physical-fitness/PhysicallFitnessReceiptList";
import OtherItemsListPF from "./pages/otheritems/OtherItemsListPF";
import OtherItemsListHP from "./pages/otheritems/OtherItemsListHP";
import PhysicalFitnessMonthlyReminder from "./pages/physical-fitness/PhysicalFitnessMonthlyReminder";
import PhysicallFitnessEnrollmentMonthly from "./pages/physical-fitness/PhysicallFitnessEnrollmentMonthly";

import { ProSidebarProvider } from "react-pro-sidebar";
import AllReceiptReport from "./pages/programme-report/AllReceiptReport";
import OnlinePaymentReport from "./pages/programme-report/OnlinePaymentReport";
import GymMemberRegistration from "./pages/gym/GymMemberRegistration";
import GymRegisteredMemberList from "./pages/gym/GymRegisteredMemberList";
import ProgramWiseOpeningBalance from "./pages/opening-balance/ProgramWiseOpeningBalance";
import ProgrammeDailyCollection from "./pages/programme-report/ProgrammeDailyCollection";
import OutstandingReport from "./pages/programme-report/OutstandingReport";
import ClubAffiliationRegistration from "./pages/club-affiliation/ClubAffiliationRegistration";
import ClubReceiptList from "./pages/club-affiliation/ClubReceiptList";
import ClubAffiliationReport from "./pages/club-affiliation/ClubAffiliationReport";
import Tournament from "./pages/tournament/Tournament";
import TournamentList from "./pages/tournament/TournamentList";
import BTATournament from "./pages/btatournament/BTATournament";
import TapCoachReport from "./pages/tap/TapCoachReport";
import JcpHpPfMemberList from "./pages/masters/JcpHpPfMemberList";
import Club from "./pages/masters/Club";
import TournamentMaster from "./pages/masters/Tournament";
import MemberDiscontinue from "./pages/member/MemberDiscontinue";
import MemberContinue from "./pages/member/MemberContinue";
import TransactionalReport from "./pages/report/TransactionalReport";
import GeneralCustomerList from "./components/masters/general-customer/GeneralCustomerList";
import GeneralCustomer from "./pages/masters/GeneralCustomer";
import StudentCollectionReport from "./pages/programme-report/StudentCollectionReport";
import ProgramTransfer from "./components/enrollment/ProgramTransfer";
import TransferProgramme from "./pages/PrgrammeTransfer/TransferProgramme";
import TransferProgrammeList from "./pages/ProgrammeTransferList/TransferProgrammeList";
import Bank from "./pages/masters/Bank";
import WaiveList from "./pages/Waive List/WaiveList";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import StudentDue from "./pages/studentDue/StudentDue";
import ProgrammeDailyCollectionNew from "./pages/programme-report/ProgrammeDailyCollectionNew";
import StudentWiseCollection from "./pages/report/StudentWiseCollection";
import TdsSection from "./pages/masters/TdsSection";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <ProSidebarProvider>
          <BrowserRouter>
            {/* <Router> */}
            <Routes>
              <Route path="/" exact element={<Login />} />
              <Route path="/login" exact element={<Login />} />
              <Route path="/logout" exact element={<Logout />} />

              <Route path="*" exact element={<NotFound />} />

              <Route element={<AdminLayout />}>
                <Route
                  exact
                  path="/dashboard"
                  key={`dashboard${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/customer"
                  key={`customer${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Customer />
                    </ProtectedRoute>
                  }
                />
                {/* <Route exact path="/registration" element={<ProtectedRoute><Registration /></ProtectedRoute>} /> */}
                <Route
                  exact
                  path="/member-list"
                  key={`member-list${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Registrationlist />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/programm-commercial"
                  key={`programm-commercial${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <ProgramCommercial />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/gst"
                  key={`gst${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Gst />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/account-group"
                  key={`account-group${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <AccountGroup />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/account"
                  key={`account${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Account />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/payment-mode"
                  key={`payment-mode${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <PaymentMode />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/programme-group"
                  key={`programme-group${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <ProgrammeGroup />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/programme"
                  key={`programme${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Programme />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/coach"
                  key={`coach${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Coach />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/occupation"
                  key={`occupation${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Occupation />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/time-slot"
                  key={`time-slot${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <TimeSlot />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/holiday"
                  key={`holiday${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Holiday />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/club"
                  key={`club${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Club />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/tournament"
                  key={`tournament${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <TournamentMaster />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/api/bank-master"
                  key={`api/bank-master${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <Bank />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/tds_section"
                  key={`tds_section${commonUtility.randomID()}`}
                  element={
                    <ProtectedRoute>
                      <TdsSection />
                    </ProtectedRoute>
                  }
                />

                {/* <Route exact path="/enrollment-jcp/:id?" element={<ProtectedRoute><JcpEnrollment /></ProtectedRoute>} />   */}

                <Route path="registration" static={false}>
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <Registration
                          key={`registration${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":memberid/"
                    element={
                      <ProtectedRoute>
                        <Registration
                          key={`registration-memberid${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="enrollment-jcp">
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <JcpEnrollment
                          key={`enrollment-jcp-index${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <JcpEnrollment key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  {/* <Route path="monthly" element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} /> */}
                </Route>

                <Route
                  path="jcp-monthly"
                  key={`jcp-monthly-route-main${commonUtility.randomID()}`}
                >
                  {/* <Route index element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} /> */}
                  <Route
                    path=":billtype/:enrollmentid/:receiptid/:paymentid"
                    key={`billtype-enrollmentid-receiptid-paymentid-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <JcpEnrollmentMonthly
                          key={`jcpenrollment-monthly-comp-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":billtype/:memberid"
                    key={`billtype-memberid-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <JcpEnrollmentMonthly
                          key={`jcpenrollment-monthly-comp2-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":billtype"
                    key={`billtype-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <JcpEnrollmentMonthly
                          key={`jcpenrollment-monthly-comp3-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="paid-list"
                    key={`paid-list-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <JcpMonthlyPaidList
                          key={`paid-list-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="jcp-reminder">
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <JcpMonthlyReminder />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="payment">
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <Payment key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":paymentid"
                    element={
                      <ProtectedRoute>
                        <Payment key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="account-report">
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <AccountReport key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":tag"
                    element={
                      <ProtectedRoute>
                        <AccountReport key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":tag/:optiontype"
                    element={
                      <ProtectedRoute>
                        <AccountReport key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="tap">
                  <Route
                    exact
                    path="membership"
                    element={
                      <ProtectedRoute>
                        <TapMemberRegistration key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="membership/:enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <TapMemberRegistration key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="membershiplist"
                    element={
                      <ProtectedRoute>
                        <TapRegisteredMemberList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="booking"
                    element={
                      <ProtectedRoute>
                        <TapBooking key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="booking/:enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <TapBooking key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="bookinglist"
                    element={
                      <ProtectedRoute>
                        <TapBookingList />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    exact
                    path="tap-coach-report"
                    element={
                      <ProtectedRoute>
                        <TapCoachReport />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="gym">
                  <Route
                    exact
                    path="membership"
                    element={
                      <ProtectedRoute>
                        <GymMemberRegistration key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="membership/:enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <GymMemberRegistration key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="membershiplist"
                    element={
                      <ProtectedRoute>
                        <GymRegisteredMemberList
                          key={commonUtility.randomID()}
                        />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                {/* <Route path="high-performance">
                <Route path=":billtype/:enrollmentid/:receiptid/:paymentid" element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} />
                <Route path=":billtype/:memberid" element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} />
                <Route path=":billtype" element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} />
                <Route path="paid-list" element={<ProtectedRoute><JcpMonthlyPaidList /></ProtectedRoute>} />
              </Route> */}

                <Route path="high-performance">
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <HpEnrollment key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="receipt-list-hp"
                    element={
                      <ProtectedRoute>
                        <HpEnrollmentReceiptList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <HpEnrollment key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="hp-monthly">
                  {/* <Route index element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} /> */}
                  <Route
                    path=":billtype/:enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <HpEnrollmentMonthly key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":billtype/:memberid"
                    element={
                      <ProtectedRoute>
                        <HpEnrollmentMonthly key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":billtype"
                    element={
                      <ProtectedRoute>
                        <HpEnrollmentMonthly key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="hp-reminder"
                    element={
                      <ProtectedRoute>
                        <HpMonthlyReminder />
                      </ProtectedRoute>
                    }
                  />
                  {/* <Route path="paid-list" element={<ProtectedRoute><JcpMonthlyPaidList /></ProtectedRoute>} /> */}
                </Route>

                <Route path="contravoucher">
                  <Route
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <ContraVoucher key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="entry/:voucher_id"
                    element={
                      <ProtectedRoute>
                        <ContraVoucher key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="list"
                    element={
                      <ProtectedRoute>
                        <ContraVoucherList />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="journalvoucher">
                  <Route
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <JournalVoucher key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="entry/:voucher_id"
                    element={
                      <ProtectedRoute>
                        <JournalVoucher key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="list"
                    element={
                      <ProtectedRoute>
                        <JournalVoucherList />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="generalvoucher">
                  <Route
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <GeneralVoucher key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="entry/:voucher_id"
                    element={
                      <ProtectedRoute>
                        <GeneralVoucher key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="list"
                    element={
                      <ProtectedRoute>
                        <GeneralVoucherList />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="purchase">
                  <Route
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <Purchase key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="entry/:purchase_id"
                    element={
                      <ProtectedRoute>
                        <Purchase key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="list"
                    element={
                      <ProtectedRoute>
                        <PurchaseList key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="taxinvoice">
                  <Route
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <TaxInvoice key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="entry/:salebill_id"
                    element={
                      <ProtectedRoute>
                        <TaxInvoice key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="list"
                    element={
                      <ProtectedRoute>
                        <TaxInvoiceList key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route
                  exact
                  path="/payment-list"
                  element={
                    <ProtectedRoute>
                      <PaymentList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/voucher-list"
                  element={
                    <ProtectedRoute>
                      <VoucherList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/other-items"
                  element={
                    <ProtectedRoute>
                      <OtherItemsListJCP key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/member-list/:program"
                  element={
                    <ProtectedRoute>
                      <JcpHpPfMemberList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                {/* <Route path="member-list">
                <Route
                  path="/member-list/:program"
                  element={
                    <ProtectedRoute>
                      <JcpHpPfMemberList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/member-list/:program/:group"
                  element={
                    <ProtectedRoute>
                      <JcpHpPfMemberList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />
              </Route> */}

                <Route
                  exact
                  path="/receipt-list-jcp"
                  element={
                    <ProtectedRoute>
                      <JcpEnrollmentReceiptList
                        key={commonUtility.randomID()}
                      />
                    </ProtectedRoute>
                  }
                />

                {/* <Route
                exact
                path="/time-schedule-report"
                element={
                  <ProtectedRoute>
                    <TimeScheduleReportView />
                  </ProtectedRoute>
                }
              /> */}

                <Route path="schedule">
                  <Route
                    path="/schedule/time-schedule-report"
                    element={
                      <ProtectedRoute>
                        <TimeScheduleReportView
                          key={commonUtility.randomID()}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/schedule/change-schedule"
                    element={
                      <ProtectedRoute>
                        <ScheduleChange key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="enrollment-pf">
                  <Route
                    index
                    element={
                      <ProtectedRoute>
                        <PhysicallFitnessEnrollment
                          key={`enrollment-pf-index${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":memberid"
                    element={
                      <ProtectedRoute>
                        <PhysicallFitnessEnrollment
                          key={commonUtility.randomID()}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":enrollmentid/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <PhysicallFitnessEnrollment
                          key={commonUtility.randomID()}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="pf-reminder"
                    element={
                      <ProtectedRoute>
                        <PhysicalFitnessMonthlyReminder />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route
                  path="pf-monthly"
                  key={`pf-monthly-route-main${commonUtility.randomID()}`}
                >
                  {/* <Route index element={<ProtectedRoute><JcpEnrollmentMonthly /></ProtectedRoute>} /> */}
                  <Route
                    path=":billtype/:enrollmentid/:receiptid/:paymentid"
                    key={`billtype-enrollmentid-receiptid-paymentid-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <PhysicallFitnessEnrollmentMonthly
                          key={`pfenrollment-monthly-comp-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":billtype/:memberid"
                    key={`billtype-memberid-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <PhysicallFitnessEnrollmentMonthly
                          key={`pfenrollment-monthly-comp2-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path=":billtype"
                    key={`billtype-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <PhysicallFitnessEnrollmentMonthly
                          key={`pfenrollment-monthly-comp3-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="paid-list"
                    key={`paid-list-${commonUtility.randomID()}`}
                    element={
                      <ProtectedRoute>
                        <JcpMonthlyPaidList
                          key={`paid-list-${commonUtility.randomID()}`}
                        />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route
                  exact
                  path="/receipt-list-pf"
                  element={
                    <ProtectedRoute>
                      <PhysicallFitnessReceiptList
                        key={commonUtility.randomID()}
                      />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/other-items-pf"
                  element={
                    <ProtectedRoute>
                      <OtherItemsListPF key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/other-items-hp"
                  element={
                    <ProtectedRoute>
                      <OtherItemsListHP key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/all-receipt-report"
                  element={
                    <ProtectedRoute>
                      <AllReceiptReport key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/all-payment-report"
                  element={
                    <ProtectedRoute>
                      <OnlinePaymentReport key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/daily-collection-report"
                  element={
                    <ProtectedRoute>
                      <ProgrammeDailyCollection
                        key={commonUtility.randomID()}
                      />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/daily-collection-report-new"
                  element={
                    <ProtectedRoute>
                      <ProgrammeDailyCollectionNew
                        key={commonUtility.randomID()}
                      />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/member-opening-balance"
                  element={
                    <ProtectedRoute>
                      <ProgramWiseOpeningBalance
                        key={commonUtility.randomID()}
                      />
                    </ProtectedRoute>
                  }
                />

                <Route path="clubaffiliation">
                  <Route
                    exact
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <ClubAffiliationRegistration
                          key={commonUtility.randomID()}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="entry/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <ClubAffiliationRegistration
                          key={commonUtility.randomID()}
                        />
                      </ProtectedRoute>
                    }
                  />
                  {/* 
                <Route
                  exact
                  path="membershiplist"
                  element={
                    <ProtectedRoute>
                      <TapRegisteredMemberList />
                    </ProtectedRoute>
                  }
                /> */}

                  <Route
                    exact
                    path="club-receipt-list"
                    element={
                      <ProtectedRoute>
                        <ClubReceiptList />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    exact
                    path="club-affiliation-report"
                    element={
                      <ProtectedRoute>
                        <ClubAffiliationReport />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="tournament">
                  <Route
                    exact
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <Tournament key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    exact
                    path="entry/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <Tournament key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    exact
                    path="tournament-receipt-list"
                    element={
                      <ProtectedRoute>
                        <TournamentList />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route path="generalreceipt">
                  <Route
                    exact
                    path="entry"
                    element={
                      <ProtectedRoute>
                        <BTATournament key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    exact
                    path="entry/:receiptid/:paymentid"
                    element={
                      <ProtectedRoute>
                        <Tournament key={commonUtility.randomID()} />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    exact
                    path="tournament-receipt-list"
                    element={
                      <ProtectedRoute>
                        <TournamentList />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route
                  exact
                  path="/member-discontinue"
                  element={
                    <ProtectedRoute>
                      <MemberDiscontinue key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/member-continue"
                  element={
                    <ProtectedRoute>
                      <MemberContinue key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/transactional"
                  element={
                    <ProtectedRoute>
                      <TransactionalReport key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/general-customer"
                  element={
                    <ProtectedRoute>
                      <GeneralCustomer key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/student-collection"
                  element={
                    <ProtectedRoute>
                      <StudentCollectionReport key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/outstanding-report"
                  element={
                    <ProtectedRoute>
                      <OutstandingReport key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/api/programtransfer"
                  element={
                    <ProtectedRoute>
                      <TransferProgramme key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/program-transfer-list"
                  element={
                    <ProtectedRoute>
                      <TransferProgrammeList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/waive-list"
                  element={
                    <ProtectedRoute>
                      <WaiveList key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/change-password"
                  element={
                    <ProtectedRoute>
                      <ChangePassword key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  exact
                  path="/student-due"
                  element={
                    <ProtectedRoute>
                      <StudentDue key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/student-wise-collection"
                  element={
                    <ProtectedRoute>
                      <StudentWiseCollection key={commonUtility.randomID()} />
                    </ProtectedRoute>
                  }
                />

                <Route path="/api" exact element={<Api />} />
                <Route
                  path="*"
                  element={<Navigate to="/dashboard" replace />}
                />
              </Route>
            </Routes>
            {/* </Router> */}
          </BrowserRouter>
        </ProSidebarProvider>
      </Provider>
    </div>
  );
}

export default App;
